import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

interface PrivacyConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PrivacyConfirmModal: React.FC<PrivacyConfirmModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className={`
        relative
        w-full
        max-w-lg
        m-4
        p-6
        rounded-2xl
        border-2
        ${isDark 
          ? "bg-black/90 border-green-500/30" 
          : "bg-white/90 border-green-900/30"
        }
      `}>
        {/* Title */}
        <h3 className={`
          text-xl
          font-bold
          mb-4
          ${isDark ? "text-green-400" : "text-green-900"}
        `}>
          {language === 'en' 
            ? 'External Form Redirect' 
            : 'Redirection vers un Formulaire Externe'}
        </h3>

        {/* Message */}
        <p className={`
          text-base
          mb-6
          ${isDark ? "text-gray-300" : "text-gray-700"}
        `}>
          {language === 'en'
            ? 'You will be redirected to our secure contact form hosted by Tally.so. Your information will be protected according to our privacy policy.'
            : 'Vous serez redirigé vers notre formulaire de contact sécurisé hébergé par Tally.so. Vos informations seront protégées conformément à notre politique de confidentialité.'}
        </p>

        {/* Buttons */}
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className={`
              px-4
              py-2
              rounded-lg
              font-medium
              transition-all
              duration-300
              ${isDark 
                ? "text-gray-300 hover:text-green-400 hover:bg-green-500/10" 
                : "text-gray-700 hover:text-green-800 hover:bg-green-900/10"
              }
            `}
          >
            {language === 'en' ? 'Cancel' : 'Annuler'}
          </button>
          <button
            onClick={onConfirm}
            className={`
              px-4
              py-2
              rounded-lg
              font-medium
              transition-all
              duration-300
              ${isDark
                ? "bg-green-500 text-black hover:bg-green-400"
                : "bg-green-600 text-white hover:bg-green-500"
              }
            `}
          >
            {language === 'en' ? 'Continue' : 'Continuer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyConfirmModal; 